export default __webpack_public_path__ + "0f8c5f76be175149fee1e16c6d56b7f4.woff2";